"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MembershipValidationError = void 0;
var MembershipValidationError;
(function (MembershipValidationError) {
    MembershipValidationError[MembershipValidationError["Invalid"] = 1] = "Invalid";
    MembershipValidationError[MembershipValidationError["NotFound"] = 2] = "NotFound";
})(MembershipValidationError = exports.MembershipValidationError || (exports.MembershipValidationError = {}));
